export const legalRoute: string = "legal";